<script setup lang="ts">
import BottomSheet from '@/organisms/BottomSheet.vue';
import BaseButton from '@/atoms/BaseButton.vue';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

const IOS_APP_ID = '1158705405';
const ANDROID_PACKAGE_NAME = 'com.libheros.pro';

async function openStoreForUpdate() {
  const platform = Capacitor.getPlatform();

  if (platform === 'ios') {
    await Browser.open({
      url: `https://apps.apple.com/app/id${IOS_APP_ID}`,
    });

    return;
  }

  if (platform === 'android') {
    await Browser.open({
      url: `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`,
    });

    return;
  }

  console.warn('Store redirection unavailable on web');
}
</script>

<template>
  <BottomSheet
    class="flex flex-col text-center justify-center"
    title="Mise à jour nécessaire"
    description="Votre version de Libheros Pro n'est plus supportée. Veuillez mettre à jour l'application pour continuer à l'utiliser"
  >
    <template #bottom-buttons>
      <BaseButton type="primary" label="Mettre à jour" @click="openStoreForUpdate" />
    </template>
  </BottomSheet>
</template>
